import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';


import { Provider } from 'react-redux'
import store  from './store'
import { RouterProvider } from 'react-router-dom';
import router from './router/router';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
  <React.StrictMode>
    
    <RouterProvider router={router} />
  </React.StrictMode>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

